import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const CookiePolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#111111] text-white px-6 md:px-12 lg:px-24 py-12">
      <div className="max-w-4xl mx-auto">
        <Button
          variant="ghost"
          className="mb-6 text-zinc-400 hover:text-white"
          onClick={() => navigate("/")}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-6">Cookie Policy</h1>
        <p className="text-zinc-400 mb-8">Last update: 29 April 2026</p>

        <div className="space-y-6 text-zinc-300 leading-7">
          <section>
            <h2 className="text-xl font-semibold text-white mb-2">What are cookies?</h2>
            <p>
              Cookies are small text files used to keep your session active and ensure platform functionality.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Cookies used on SaaS-Radar</h2>
            <p>We use technical and session cookies required for authentication and security.</p>
            <p>No dedicated analytics cookie has been declared at this time.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Managing cookies</h2>
            <p>
              You can control cookies through your browser settings. Disabling essential cookies may impact
              your ability to use the platform.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
